/**
 * Force Alt Text on All Images (Shopify equivalent)
 *
 * Ensures EVERY front-end <img> has alt text — including images injected by
 * apps, hard-coded HTML in custom-liquid blocks, headers, and footers.
 *
 * Shopify has no PHP layer and no central "media library alt API" queryable
 * from Liquid for arbitrary file URLs, so this runs in the browser and:
 *   1. Honors any existing alt / data-alt / aria-label / parent <a title>.
 *   2. Falls back to deriving readable alt text from the image filename
 *      (the Shopify CDN URL), stripping size suffixes like _300x300 and
 *      extensions, then title-casing.
 *
 * Modern crawlers (Googlebot, Bingbot) execute JS and index the resulting
 * DOM, so the populated alt attributes are visible for SEO.
 */
(function () {
  'use strict';

  function altFromUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      var filename = (u.pathname.split('/').pop() || '').split('?')[0];
      filename = filename.replace(/\.(jpe?g|png|gif|webp|svg|avif|bmp|tiff?)$/i, '');
      filename = filename.replace(/_(\d+x\d*|x\d+)(_crop_[a-z]+)?$/i, '');
      filename = filename.replace(/[-_]+/g, ' ').trim();
      if (!filename) return '';
      return filename.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    } catch (e) {
      return '';
    }
  }

  function deriveAlt(img) {
    var alt = img.getAttribute('data-alt') || img.getAttribute('aria-label');
    if (alt && alt.trim()) return alt.trim();

    var anchor = img.closest && img.closest('a');
    if (anchor) {
      var title = anchor.getAttribute('title') || anchor.getAttribute('aria-label');
      if (title && title.trim()) return title.trim();
    }

    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-srcset');
    if (src && src.indexOf(',') !== -1) src = src.split(',')[0].trim().split(' ')[0];
    return altFromUrl(src);
  }

  function fixImage(img) {
    if (!img || img.nodeType !== 1 || img.tagName !== 'IMG') return;
    var current = img.getAttribute('alt');
    if (current !== null && current.trim().length > 0) return;
    var alt = deriveAlt(img);
    if (alt) img.setAttribute('alt', alt);
  }

  function fixAllImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img:not([alt]), img[alt=""]');
    for (var i = 0; i < imgs.length; i++) fixImage(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fixAllImages(); });
  } else {
    fixAllImages();
  }
  window.addEventListener('load', function () { fixAllImages(); });

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') {
            fixImage(node);
          } else if (node.querySelectorAll) {
            fixAllImages(node);
          }
        }
        if (mutations[i].type === 'attributes' && mutations[i].target && mutations[i].target.tagName === 'IMG') {
          fixImage(mutations[i].target);
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-src', 'alt']
    });
  }
})();
